<template>
  <div class="c-playlists-name-expand-function">
    <div class="name">

      <p class="name__text">{{ data.name }}</p>

    </div>
    <!-- <div class="function">
      <music-function/>
    </div> -->
  </div>
</template>
<script>
import { defineComponent } from 'vue';
// import MusicFunction from '@/components/Global/MusicPlayer/MusicFunction.vue';

export default defineComponent({
  name: 'TrackDivideFunction',
  // components: {
  //   MusicFunction,
  // },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    column: {
      type: Object,
      default: () => ({}),
    },
    idx: {
      type: Number,
    },
  },
});
</script>
<style lang="scss" scoped>
.c-playlists-name-expand-function {
  width: 100%;
  @include flex();

}

.name {
  flex: none;
  // width: 300px;
  @include flex();

  &__text {

    @include font-style($c-assist6, 14, normal, 0.8px, 26px);
  }

}

.function {
  flex: 1;
}
</style>
